import { Apple, Smartphone } from "lucide-react";
import { SiApple, SiGooglefit, SiFitbit, SiGarmin, SiSamsung } from "react-icons/si";

const items = [
  { Icon: SiApple, label: "Apple Health" },
  { Icon: SiGooglefit, label: "Google Fit" },
  { Icon: SiFitbit, label: "Fitbit" },
  { Icon: SiGarmin, label: "Garmin" },
  { Icon: null, label: "Whoop" },
  { Icon: null, label: "Oura" },
  { Icon: SiSamsung, label: "Samsung Health" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="relative py-20 border-y border-white/5 bg-[#070707]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-center text-[11px] uppercase tracking-[0.28em] text-white/45 font-semibold mb-10">
          Reads every signal your body sends
        </p>
        <div className="fade-edges flex flex-wrap items-center justify-center gap-x-12 gap-y-7">
          {items.map(({ Icon, label }) => (
            <div
              key={label}
              data-testid={`trust-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="flex items-center gap-2 text-white/55 hover:text-white transition-colors"
            >
              {Icon ? <Icon className="w-6 h-6" /> : (
                <span className="font-display font-black tracking-tight text-base">{label}</span>
              )}
              {Icon && <span className="font-display font-semibold text-sm">{label}</span>}
            </div>
          ))}
        </div>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
          <span
            data-testid="badge-ios"
            className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 text-xs text-white/70 font-medium"
          >
            <Apple className="w-3.5 h-3.5" />
            iOS · Coming soon
          </span>
          <span
            data-testid="badge-android"
            className="inline-flex items-center gap-2 glass rounded-full px-4 py-2 text-xs text-white/70 font-medium"
          >
            <Smartphone className="w-3.5 h-3.5" />
            Android · Coming soon
          </span>
        </div>
        <p className="mt-5 text-center text-[11px] text-white/40 font-mono uppercase tracking-[0.18em]">
          Wearable sync available on Genius tier
        </p>
      </div>
    </section>
  );
}
